import { Project as ProjectModel } from '@material-bank/projects-api';
import { jsonToFormData } from './jsonToFormData';

interface CreateOrderPayload {
  product_sku: number[];
  project_id: number;
  project_name: string;
  project_type: string;
  sample_type: string;
  actions: string;
  qty: number;
  quote_details?: string;
  attachment_id?: number;
}

interface CreateOrderResponse {
  message?: string; // eg. "Previous order placed with same sku"
  status: string; // 'success'|'failed
}

type MeaningfulMoveAction =
  | 'See Pricing'
  | 'Download'
  | 'Request quote'
  | 'Get distributor';

export const getCreateOrderPayload = (
  product_sku: string,
  currentProjectData: Pick<ProjectModel, 'externalId' | 'title' | 'type'>,
  action: MeaningfulMoveAction,
  {
    quoteDetails,
    attachmentId,
    attachmentPimId,
  }: {
    quoteDetails?: string;
    attachmentId?: number; // Deprecated, use attachmentPimId instead
    attachmentPimId?: string;
  } = {},
) => ({
  product_sku: [parseInt(product_sku)],
  project_id: currentProjectData?.externalId,
  project_name: currentProjectData?.title,
  project_type: currentProjectData?.type?.externalId?.toString(),
  sample_type: 'Digital',
  actions: action,
  qty: 1,
  ...(action === 'Request quote' && quoteDetails
    ? { quote_details: quoteDetails }
    : {}),
  ...(action === 'Download' && attachmentPimId
    ? { attachment_pim_id: attachmentPimId }
    : {}),
  ...(action === 'Download' && attachmentId
    ? { attachment_id: attachmentId }
    : {}),
});

/**
 * Creates an order by sending a POST request with the specified payload.
 *
 * @param payload An object adhering to `CreateOrderPayload` with the necessary order information.
 * @returns A promise. Orders are queued no order id is returned.
 * @throws An error if the POST request fails or the response is not OK.
 */
export const createOrder = async (
  payload: CreateOrderPayload,
): Promise<CreateOrderResponse> => {
  try {
    const response = await fetch('/digitalcatalogdownloads/order/place', {
      method: 'POST',
      body: jsonToFormData(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
